import React, { useState, useRef, useEffect } from 'react';
import { Box, Collapse, Paper, IconButton } from '@mui/material';
import { Info } from 'src/icons/InfoXs';
import Papper from 'src/icons/Papper';
import ItemMenu from 'src/widgets/Menu/components/ItemMenu';

const SupportButton: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleSupportClick = () => {
        window.open('https://t.me/tghunter_manager');
        setIsOpen(false);
    };

    const handleAboutClick = () => {
        window.open('https://tghunter.ru/');
        setIsOpen(false);
    };

    return (
        <Box
            ref={dropdownRef}
            sx={{
                position: 'fixed',
                bottom: 24,
                right: 24,
                zIndex: 1000,
            }}
        >
            <IconButton
                onClick={handleToggle}
                sx={{
                    width: 56,
                    height: 56,
                    backgroundColor: 'background.paper',
                    border: '1px solid #E3ECF3',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    '&:hover': {
                        backgroundColor: 'background.default',
                    },
                }}
            >
                <Info />
            </IconButton>
            <Collapse
                in={isOpen}
                sx={{
                    position: 'absolute',
                    bottom: '100%',
                    right: 0,
                    mb: 1,
                    minWidth: 200,
                }}
            >
                <Paper
                    elevation={4}
                    sx={{
                        borderRadius: 2,
                        overflow: 'hidden',
                        backgroundColor: '#fff',
                        py: 1.5,
                    }}
                >
                    <ItemMenu
                        icon={<Info />}
                        title="Поддержка"
                        onAction={handleSupportClick}
                    />
                    <ItemMenu
                        icon={<Papper />}
                        title="О приложении"
                        onAction={handleAboutClick}
                    />
                </Paper>
            </Collapse>
        </Box>
    );
};

export default SupportButton;
